import gql from 'graphql-tag';

export const query = gql`
  query AccessAndJob($input: JobInput!) {
    job(input: $input) {
      ... on JobResponseSuccess {
        result {
          id
          listingDate
          createdDate
          expiryDate
          positionId {
            ... on PositionIdResponseSuccess {
              result
            }
            ... on ResponseError {
              error
            }
          }
          listingId {
            ... on ListingIdResponseSuccess {
              result
            }
            ... on ResponseError {
              error
            }
          }
          questionnaireUrl
          daysRemaining
          owner {
            fullName
          }
          id
          status
          postChannel
          title
          adType
          productDisplayName
          billableApplicants {
            ... on BillableApplicantsResponseSuccess {
              data {
                billableApplicantsCount {
                  ... on BillableApplicantsCountResponseSuccess {
                    result
                  }
                  ... on ResponseError {
                    error
                  }
                }
                maxBillableApplicants {
                  ... on MaxBillableApplicantsResponseSuccess {
                    result
                  }
                  ... on ResponseError {
                    error
                  }
                }
              }
            }
            ... on ResponseError {
              error
            }
          }
          referenceCheckBalance {
            ... on JobReferenceCheckBalanceResponseSuccess {
              result {
                ... on JobReferenceCheckExpired {
                  budgetType
                }
                ... on JobReferenceCheckBalance {
                  budgetType
                  availableBalance
                  totalBalance
                }
              }
            }
            ... on ResponseError {
              __typename
              error
            }
          }
          workType
          minSalary
          maxSalary
          salaryCurrency
          payType
          salaryText
          categoryName
          subCategoryName
          categoryId
          locations {
            id
            description
            country
            type
            parent {
              id
              parent {
                id
                parent {
                  id
                }
              }
            }
          }
          advertiserJobReference
          performanceRating {
            status
          }
          createdDate
          canBeUpgraded
          canPurchaseReferenceChecks
          canShowHomeLocationFilterInCandidateManagement
          canShowNationalityFilterInCandidateManagement
          placementV2 {
            ... on JobPlacementV2ResponseSuccess {
              result {
                canShowPlacementPrompt
                status
              }
            }
            ... on ResponseError {
              error
            }
          }
          isIndirectJobButCanBeChanged
          highFitCount {
            ... on HighFitCountResponseSuccess {
              result
            }
            ... on ResponseError {
              error
            }
          }
        }
      }
      ... on CorrectUserIncorrectHirerResponseSuccess {
        result {
          correctHirerAccountId
        }
      }
      ... on ResponseError {
        error
      }
    }
  }
`;
